/* Microdacyn redesign – document pages.

   The legal and info pages are written in the Shopify page editor, so the theme cannot
   know their structure ahead of time. This reads whatever headings came back and builds
   the contents rail from them; if a page has fewer than three, the rail stays hidden and
   the text runs full width instead of leaving an empty column.

   Also wraps wide tables in a horizontal scroller, because pasted tables are the one
   thing that reliably breaks a phone layout. */
(() => {
  const rte = document.querySelector('.mdc-rte');
  if (!rte) return;

  /* --- tables --- */
  rte.querySelectorAll('table').forEach((table) => {
    if (table.parentElement && table.parentElement.classList.contains('mdc-rte__scroll')) return;
    const wrap = document.createElement('div');
    wrap.className = 'mdc-rte__scroll';
    table.replaceWith(wrap);
    wrap.appendChild(table);
  });

  /* --- contents --- */
  const nav = document.querySelector('.mdc-doc__nav');
  const grid = document.querySelector('.mdc-doc__grid');
  if (!nav || !grid) return;

  const slug = (text, i) =>
    (text || '')
      .toLowerCase()
      .normalize('NFD')
      .replace(/[̀-ͯ]/g, '')
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-+|-+$/g, '')
      .slice(0, 60) || 'sectiune-' + i;

  const headings = [...rte.querySelectorAll('h2')].filter((h) => h.textContent.trim());
  const min = parseInt(nav.dataset.min || '3', 10);
  if (headings.length < min) {
    nav.hidden = true;
    grid.classList.add('mdc-doc__grid--plain');
    return;
  }

  const list = document.createElement('ol');
  const links = headings.map((h, i) => {
    if (!h.id) h.id = slug(h.textContent.trim(), i);
    const li = document.createElement('li');
    const a = document.createElement('a');
    a.href = '#' + h.id;
    a.textContent = h.textContent.trim();
    li.appendChild(a);
    list.appendChild(li);
    return a;
  });
  nav.appendChild(list);

  /* Scrollspy. rootMargin pins the "current" line to the band just under the sticky
     header, so the highlighted entry is the one you are actually reading. */
  if (!('IntersectionObserver' in window)) return;
  const seen = new Map();
  const mark = () => {
    let current = null;
    headings.forEach((h) => {
      if (seen.get(h)) current = h;
    });
    if (!current) current = headings.find((h) => h.getBoundingClientRect().top > 0) || headings[0];
    links.forEach((a, i) => a.classList.toggle('is-current', headings[i] === current));
  };
  const obs = new IntersectionObserver(
    (entries) => {
      entries.forEach((e) => seen.set(e.target, e.isIntersecting));
      mark();
    },
    { rootMargin: '-120px 0px -70% 0px', threshold: 0 }
  );
  headings.forEach((h) => obs.observe(h));
  mark();
})();
